import * as React from "react";

const ThumbsDown = (props: { color?: string; isActive?: boolean }) => {
    if (props.isActive) {
        return (
            <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                <g clipPath="url(#clip0_666_1324)">
                    <path
                        d="M12.5977 2.055e-06L15.3103 2.29215e-06C15.6874 2.32511e-06 16 0.314454 16 0.693644L16 10.4046C16 10.7838 15.6874 11.0983 15.3103 11.0983L12.5977 11.0983L12.5977 2.055e-06Z"
                        fill={props.color}
                    />
                    <path
                        d="M11.1816 1.39654C11.1816 0.628913 10.5655 1.18329e-05 9.80227 1.17662e-05L4.18388 1.1275e-05C3.3563 1.12027e-05 2.5471 0.536426 2.26204 1.26706L0.0551451 6.72371L-2.68684e-05 6.98267L-2.70463e-05 9.01735C-2.71465e-05 10.1642 0.928709 11.0983 2.06894 11.0983L5.68273 11.0983L5.15859 13.133C5.01147 13.8821 5.22296 14.6497 5.7471 15.1769L6.48273 15.8243C6.75859 16.0648 7.16319 16.0555 7.42066 15.7965L10.7954 12.4671C11.062 12.2081 11.2092 11.8474 11.2092 11.4682C11.2 9.64625 11.1632 4.02313 11.1816 1.38729L11.1816 1.39654Z"
                        fill={props.color}
                    />
                </g>
                <defs>
                    <clipPath id="clip0_666_1324">
                        <rect width="16" height="16" fill="white" transform="translate(16 16) rotate(-180)" />
                    </clipPath>
                </defs>
            </svg>
        );
    }
    return (
        <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M2.06897 11.0983L5.68276 11.0983L5.15862 13.133C5.01149 13.8821 5.22299 14.6497 5.74713 15.1769L6.48276 15.8243C6.74942 16.0647 7.16322 16.0555 7.42069 15.7965L12.1839 11.0983L15.3103 11.0983C15.6874 11.0983 16 10.7838 16 10.4046L16 0.693652C16 0.314462 15.6874 1.04631e-05 15.3103 1.04301e-05L4.18391 9.45742e-06C3.35632 9.38507e-06 2.54713 0.536424 2.26207 1.26706L0.0551728 6.72371C0.0183915 6.80695 7.95418e-07 6.89943 7.88141e-07 6.98267L6.10264e-07 9.01735C5.11623e-07 10.1457 0.947127 11.0983 2.06897 11.0983ZM14.6207 9.71099L12.5977 9.71099L12.5977 1.38729L14.6207 1.38729L14.6207 9.71099ZM1.37931 7.1214L3.54023 1.78498C3.61379 1.60001 3.90805 1.38729 4.18391 1.38729L11.2184 1.38729L11.2184 10.1179L6.91494 14.363L6.69425 14.1688C6.49195 13.9653 6.47356 13.6324 6.51035 13.4474L7.24598 10.5804C7.30115 10.3769 7.24598 10.1549 7.12644 9.9792C6.9977 9.81273 6.7954 9.71099 6.58391 9.71099L2.07816 9.71099C1.71954 9.71099 1.38851 9.37804 1.38851 9.01735L1.38851 7.1214L1.37931 7.1214Z"
                fill={props.color}
            />
        </svg>
    );
};

export default ThumbsDown;
